import React, { PropsWithChildren } from "react";
import * as Sentry from "@sentry/react";
//#region types
import { ErrorBoundaryProps, ErrorBoundaryState } from "models/propTypes/errorMessagePropTypes";
//#endregion
//#region components
import SomethingWentWrong from "./somethingWentWrong";
//#endregion

class ErrorBoundary extends React.Component<PropsWithChildren<ErrorBoundaryProps>, ErrorBoundaryState> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Log to Sentry
    Sentry.withScope((scope) => {
      scope.setExtras({
        componentStack: errorInfo.componentStack,
        subComponentType: this.props.subComponentType?.toString(),
        location: {
          origin: window.location.origin,
          path: window.location.pathname,
        },
      });
      Sentry.captureException(error);
    });
  }

  render() {
    return this.state.hasError ? <SomethingWentWrong /> : this.props.children;
  }
}

export default ErrorBoundary;
